import { render, staticRenderFns } from "./SuppliersRegistryEditForm.vue?vue&type=template&id=283c9835"
import script from "./SuppliersRegistryEditForm.vue?vue&type=script&lang=js"
export * from "./SuppliersRegistryEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports